import { Button, Grid, Paper, Typography, useTheme } from '@mui/material'
import { PoolTypeEnum } from '@shared/Enums'

import { ETH_ADDR_ZERO, EthAddr } from '@shared/SchemaTypes'

import React, { useEffect } from 'react'
import { OtStoreState, useOtDispatch, useOtSelector } from '@react/redux/store'
import { PoolStateChangeEnum, poolStateChangeTx } from '@react/signedTxs/poolStateChangeTx'
import { poolActions } from '@react/redux/poolSlice'

import { logOT } from '@shared/loggingShared'

interface Props {
  poolAddr: EthAddr
  handleComplete: () => void
}

export const ActivateVaultStep: React.FC<Props> = ({ poolAddr, handleComplete }) => {
  const theme = useTheme()
  const poolBaseOverviewCTO = useOtSelector(
    (state: OtStoreState) => state.poolState.poolOverviewCTOs[poolAddr ?? ETH_ADDR_ZERO]
  )

  const dispatch = useOtDispatch()
  const [closeEvent, setCloseEvent] = React.useState<string>('')
  const lastPoolEvent = useOtSelector((state) => state.poolState.lastEvent)
  useEffect(() => {
    logOT.info('lastPoolEvent', lastPoolEvent, 'closeEvent', closeEvent)
    if (closeEvent != '' && lastPoolEvent == closeEvent) {
      handleComplete()
    }
  }, [closeEvent, lastPoolEvent])

  const activateVault = async () => {
    setCloseEvent(poolActions.activatePoolSuccess.type)
    dispatch(poolStateChangeTx({ poolAddr, poolState: PoolStateChangeEnum.ACTIVATE }))
  }

  logOT.info('ActivateVaultStep', poolAddr, poolBaseOverviewCTO)
  return (
    <Paper sx={{ margin: 4, padding: 4 }}>
      <Grid container>
        <Typography alignContent={'left'} variant="body2" component="div" style={{ textDecoration: 'none' }}>
          {poolBaseOverviewCTO.name}
        </Typography>
        {poolBaseOverviewCTO.poolType === PoolTypeEnum.FlexibleRate && (
          <Typography variant="captionMuted" margin="dense" marginTop={-10}>
            Flexible Term
          </Typography>
        )}
      </Grid>

      <Grid item xs={12} sx={{ justifyContent: 'center' }}>
        <Button
          sx={{
            backgroundColor: theme.palette.fg.main,
            color: '#FFFFFF',
            padding: '11px 16px 11px 16px',
            borderRadius: '6px',
          }}
          onClick={() => {
            activateVault()
          }}
          variant={'contained'}
        >
          <Typography variant={'buttonBold'}>Activate Vault</Typography>
        </Button>
      </Grid>
    </Paper>
  )
}
